<template>
    <div class="friend-list">
                  <div class="row">
                    <h3 style="color:#ff5566; padding:1em;">Top activity products</h3>
                    <div class="col-md-4 col-sm-4 col-xs-6" v-for="(product,index) in products" :key="index">
                      <div v-if="(product.product_items.length != 0)" style="min-height:23em; max-height:22em;">
                        <a :href="'/'+product.product_business_username+'/'+product.product_url_name" style="color:inherit; text-decoration: none;">
                          <div v-for="(product_item,index2) in product.product_items" :key="index2" class="friend-card" style="min-height:22em; max-height:22em; border-bottom-color: rgb(182, 176, 176)">
                           <div v-if="index2 == 0">
                              <div style="height:10em">
                                  <img :src="product_item.product_item_image" class="sp-prd-img" alt="photo" />
                              </div>
                             
                              <div class="card-info">
                                <div class="friend-info">
                                  <a href="#" class="pull-right text-green" style="font-size:12px;">@{{product.product_business_name}}</a>
                                  <br/>
                                  <h5 style="height:3em"><a href="#" class="profile-link">{{product.product_name}}</a></h5>
                                  <p>₦{{product_item.product_item_price.toLocaleString('en', {useGrouping:true})}}</p>
                                  <!-- <a :href="'/'+sellpoint.business_username" class="pull-right" style="color:rgb(41, 34, 88); text-decoration: none;"><i class="fa fa-circle"></i> visit stall</a> -->
                                  <div class="pull-right" style="margin-bottom: 1em">
                                      <a class="btn text-red" title="Like"><i class="fa fa-heart-o" style="font-size:14px;"></i> </a>
                                      <a class="btn text-red" title="Add to Cart"><i class="fa fa-shopping-cart" style="font-size:14px;"></i> </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                        </div>
                        </a>
                      </div>
                    </div>
                  </div>
    </div>
</template>

<script>
import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'SearchBox',
    data () {
      return {
        products:{}
      }
  },

    methods: {
   
        getMarketActivityProducts(){
            let offset = 0; let limit = 20;
            service.getMarketActivityProducts(this,service.market_app_name,offset,limit).then(response => {
                if(response.body.status == 200) {
                    this.products = response.body.data;
                    this.loading = false;
                }
            }).catch((err) => {})
                
        },
     
    },
    created: function(){
        this.getMarketActivityProducts();
    }
}
</script>


// WEBPACK FOOTER //
// activeproducts.vue?6a91a28b